export interface PayorInterface {
  allowmemberimport: boolean;
  allowmrscost: boolean;
  allownewriders: boolean;
  allowsivr: boolean;
  alternatephonenumber: number;
  billingscheduleid: number;
  city: string;
  contactname: string;
  contacttitle: string;
  description: string;
  email: string;
  enableplans: boolean;
  hasexcludeproviders: boolean;
  hasfrequentfacilities: boolean;
  isactive: boolean;
  isallowmembersmaketrips: boolean;
  isauthrequired: boolean;
  isbillpatient: boolean;
  iseditmanualmiles: boolean;
  isfacilityrequired: boolean;
  isgeofenced: boolean;
  isidrequired: boolean;
  ismodifierrequired: boolean;
  isreasonfortransportrequired: boolean;
  isServiceProviderRequired: boolean;
  isuniqueidrequired: boolean;
  showimportdateselector: boolean;
  payorid: number;
  payortypeid: number;
  phonenumber: number;
  roomaptnumber: number;
  state: string;
  streetaddress: string;
  zip: number;
}

export interface ISimplyReasonTransport {
  simplyreasontransportid: number;
  description: string;
}



export interface IProfitCenter {
  profitcenterid: number;
  exportcode: number;
  description: string;
  emailcontactinformation: string;
  speedcode: string;
  billingcontactname: string;
  billingemailto: string;
  billingemailcc: string;
  payorid: number;
  isactive: boolean;
  isemailperattachment: boolean;
}


export enum ActionEnum {
  CloseFormAndRefreshGrid = 1,
  OpenForm = 2,
  CloseForm = 3,
  OpenGridProfit = 4,
  CloseGridProfit = 5,
  None = 6
}

 export enum KeyCodeEnum {
  Numpad0 = 95,
  Numpad9 = 106,
  Digit0 = 47,
  Digit9 = 58,
  Backspace = 8,
  Dot = 190
};




// WEBPACK FOOTER //
// ./src/app/core/interfaces/payor.interface.ts